// Shared genre list used across Books, Authors, and Publishers filter sidebars.
export const GENRES = ["उपन्यास", "कविता", "कहानी", "नाटक", "आत्मकथा", "निबंध", "महाकाव्य"];
